import { CSS_CDN_URL } from '@wix/design-system';

export function loadCSS(): void {
  const link = document.createElement('link');
  link.href = CSS_CDN_URL;
  link.rel = 'stylesheet';
  link.onerror = () => {
    console.error(`Failed to load CSS from ${CSS_CDN_URL}`);
  };
  document.head.append(link);
}
